export default "<iframe src='../../../assets/Documents/Surina_John_CV.pdf' width=\"100%\" height=\"600px\"></iframe>"